import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, map, of, switchMap, tap, throwError } from 'rxjs';
import { ApiResponse } from 'app/models/api-response';
import { StoreDto } from 'app/models/store-dto';

// واجهة للكاش تحتوي على وقت الانتهاء
export interface StoreCache {
  store: StoreData;
  timestamp: number;      // وقت الحفظ
  expiresAt: number;      // وقت الانتهاء
}
export interface StoreData {
  id: number;
  name: string;
  branch_id: number;
  lat: string;
  long: string;
}

export interface AddressResponse {
  success: boolean;
  message: string;
  store: StoreData;
}

@Injectable({
  providedIn: 'root'
})
export class StoreService {
  private get apiUrl(): string {
    const base = localStorage.getItem('apiURL');
    if (!base) throw new Error('apiURL not ready');
    return base + '/api/v2';
  }

  private readonly CACHE_KEY = 'nearest_default_store';
  // ⏱️ مدة الصلاحية: 1 ساعة = 60 * 60 * 1000 مللي ثانية
  // يمكنك تغييرها لأي مدة: 30 دقيقة = 1800000، 2 ساعة = 7200000
  private readonly EXPIRY_DURATION_MS = 3600000;

  constructor(private http: HttpClient) { }

  getStores(page: number, pageSize: number = 20): Observable<ApiResponse<StoreDto>> {

    return this.http.get<ApiResponse<StoreDto>>(this.apiUrl + `/stores?page=${page}&pageSize=${pageSize}`
    );
  }
  /**
   * الحصول على عناوين المستخدم
   */
  getMainStore(lat: string, long: string): Observable<ApiResponse<StoreData>> {

    return this.http.get<ApiResponse<StoreData>>(this.apiUrl + `/stores/main-store?lat=${lat}&long=${long}`
    );
  }
  getNearestStore(): Observable<StoreData | null> {
    return this.getNearestStoreAnyOne().pipe(
      switchMap(store => {
        if (store != null) {
          return of(store);
        }
        return this.fetchFromBackend().pipe(
          catchError(err => {
            console.error('⚠️ فشل جلب أقرب متجر:', err);
            return of(null);
          })
        );
      })
    );
  }

  getNearestStoreAnyOne(): Observable<StoreData | null> {
    const cached = this.getCachedData();

    if (cached && !this.isExpired(cached)) {
      console.log("cached");
      return of(cached.store);
    }
    return of(null)
  }

  /** جلب البيانات من الـ API */
  private fetchFromBackend(): Observable<StoreData | null> {
    return this.http.get<AddressResponse>(`${this.apiUrl}/user/shipping/default_address_store`).pipe(
      tap(res => {
        if (res.success && res.store) {
          this.saveToCache(res.store);
          console.log("new not cached");

        }
      }),
      map(res => res.store ?? null)
    );
  }

  /** قراءة الكاش من localStorage */
  private getCachedData(): StoreCache | null {
    const data = localStorage.getItem(this.CACHE_KEY);
    return data ? JSON.parse(data) : null;
  }

  /** حفظ البيانات مع وقت الانتهاء */
  public saveToCache(store: StoreData): void {
    const now = Date.now();
    const cache: StoreCache = {
      store,
      timestamp: now,
      expiresAt: now + this.EXPIRY_DURATION_MS
    };
    localStorage.setItem(this.CACHE_KEY, JSON.stringify(cache));
  }

  /** التحقق من انتهاء المدة */
  private isExpired(cache: StoreCache): boolean {
    return Date.now() > cache.expiresAt;
  }

  /** 🗑️ مسح الكاش يدوياً (مفيد عند تغيير العنوان أو تسجيل الخروج) */
  clearCache(): void {
    localStorage.removeItem(this.CACHE_KEY);
  }



}